import { render, staticRenderFns } from "./InnerCard.vue?vue&type=template&id=1963a974&scoped=true"
import script from "./InnerCard.vue?vue&type=script&lang=js"
export * from "./InnerCard.vue?vue&type=script&lang=js"
import style0 from "./InnerCard.vue?vue&type=style&index=0&id=1963a974&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1963a974",
  null
  
)

export default component.exports